import React from 'react';

import Close from '../../assets/icon-close-white.svg';
import './header-popup.css';

class headerPopup extends React.Component {
    UNSAFE_componentWillMount() {
        document.body.classList.add('overlay-hide');
        if (document.getElementById('sticky-wrapper')) {
            document.getElementById('sticky-wrapper').style.zIndex = '1';
            if (document.getElementById('menu-text')) {
              document.getElementById('menu-text').style.zIndex = '1';
            }
        }
    }
    componentWillUnmount() {
        document.body.classList.remove('overlay-hide');
        if (document.getElementById('sticky-wrapper')) {
            document.getElementById('sticky-wrapper').style.zIndex = '9999';
            if (document.getElementById('menu-text')) {
              document.getElementById('menu-text').style.zIndex = '999';
            }
        }
    }

    render() {
        return (
            <div className="modal">
                <div className="popup-exit">
                    <div className="modal-body">
                        <div className="popup-header">
                            <h3>Do you really want to exit?</h3>
                            <img src={Close} alt='close' className="close-icon" onClick={() => this.props.closePopup()} />
                        </div>
                        <p>Get food on your train. Order now in just 3 easy steps</p>
                        <button onClick={() => this.props.closePopup()} type="button" className="continue" id="continuewith" >Continue with my order</button>
                        <a href="https://www.railyatri.in/m" onClick={() => this.props.closePopup()} id="exitwith" className="exit">Exit anyway!</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default headerPopup;